import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['newCollection'];
  static values = { collectionField: String };

  appendBoardData({ formData }) {
    formData.append('data', window.ed._shared.getBoardData());
  }

  collectionChanged({ detail: { value } }) {
    const creating = value === '';

    this.element.elements.namedItem(this.collectionFieldValue).disabled = creating;
    this.newCollectionTarget.hidden = !creating;
    this.newCollectionTarget.disabled = !creating;

    if (creating) {
      this.newCollectionTarget.querySelector('input').focus();
    }
  }

  submitted({ detail }) {
    if (detail.success) {
      window.ed.featureActionsService.add('templates_board_saved_as_template');
    }
  }
}
